import Client from './Client'

const GuideAPI = {}
const v1Url = '/v1/guide'

GuideAPI.install = (Vue) => {
  const vue = Vue
  vue.prototype.$GuideAPI = {
    getNavigation(code) {
      let uid = 'followAppWebGen-test-uid112'
      if (process.env.NODE_ENV === 'production') {
        const userInfo = localStorage.getItem('userInfo')
        uid = JSON.parse(userInfo).uid
      }
      const data = {
        code,
        uid,
      }
      return Client.get(`${v1Url}/scan/code/${data.code}/uid/${data.uid}`)
    },
    getUserHistoricalData() {
      let uid = '3d579b6f-d4f9-4c72-b3cc-c3046cf43243'
      if (process.env.NODE_ENV === 'production') {
        const userInfo = localStorage.getItem('userInfo')
        uid = JSON.parse(userInfo).uid
      }
      return Client.get(`${v1Url}/${uid}`)
    },
  }
}

export default GuideAPI
